// Re-export risk rating types
export * from './riskRating';

export interface Address {
  moniker: string;
  partialAddress: string;
  picklist: string;
}

/** @deprecated — used by legacy AddressLookup only. Safe to remove once legacy AddressLookup component is fully deleted. */
export interface LegacyAddress extends Address {
  fullAddress: boolean;
  state: string;
  postcode: string;
  score: number;
}

export interface ManualAddress {
  street: string;
  suburb: string;
  state: string;
  postcode: string;
  effectiveDate: string;
  perilLevel: PerilLevel;
}

export interface AddressValidationStatus {
  isValid: boolean;
  isVerified: boolean;
}

/* Perils */
export interface Flood {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Cyclone {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Bushfire {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Storm {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface OverlandFlow {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Earthquake {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Fire {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Waterdamage {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface MaliciousDamage {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Impact {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Other {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface AccidentalDamage {
  sourceType: string;
  contentsRiskGroup: number;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Model {
  sourceType: string;
  buildingRiskGroup: number;
  biRiskGroup: number;
}

export interface Stock {
  sourceType: string;
  theftRiskGroup: number;
}

export interface Contents {
  sourceType: string;
  theftRiskGroup: number;
}

export interface Tobacco {
  sourceType: string;
  theftRiskGroup: number;
}

export interface Liquor {
  sourceType: string;
  theftRiskGroup: number;
}

export interface WithoutForceableEntry {
  sourceType: string;
  theftRiskGroup: number;
}

export interface TheftModel {
  sourceType: string;
  theftRiskGroup: number;
}

export interface Intransit {
  sourceType: string;
  moneyRiskGroup: number;
}

export interface InResidence {
  sourceType: string;
  moneyRiskGroup: number;
}

export interface BusinessHours {
  sourceType: string;
  moneyRiskGroup: number;
}

export interface AfterHours {
  sourceType: string;
  moneyRiskGroup: number;
}

export interface InSafe {
  sourceType: string;
  moneyRiskGroup: number;
}

export interface MoneyModel {
  sourceType: string;
  moneyRiskGroup: number;
}

export interface Glass {
  sourceType: string;
  glassRiskGroup: number;
}

export interface NoSigns {
  sourceType: string;
  glassRiskGroup: number;
}

export interface GlassAdditionalSI {
  sourceType: string;
  glassRiskGroup: number;
}

export interface GlassModel {
  sourceType: string;
  glassRiskGroup: number;
}

export interface Perils {
  flood: Flood;
  cyclone: Cyclone;
  bushfire: Bushfire;
  storm: Storm;
  overlandFlow: OverlandFlow;
  earthquake: Earthquake;
  fire: Fire;
  waterDamage: Waterdamage;
  maliciousDamage: MaliciousDamage;
  impact: Impact;
  other: Other;
  accidentalDamage: AccidentalDamage;
  model: Model;
  stock: Stock;
  contents: Contents;
  tobacco: Tobacco;
  liquor: Liquor;
  withoutForceableEntry: WithoutForceableEntry;
  theftModel: TheftModel;
  inTransit: Intransit;
  inResidence: InResidence;
  businessHours: BusinessHours;
  afterHours: AfterHours;
  inSafe: InSafe;
  moneyModel: MoneyModel;
  glass: Glass;
  noSigns: NoSigns;
  glassAdditionalSI: GlassAdditionalSI;
  glassModel: GlassModel;
}

export enum PerilLevel {
  NFID = 'NFID',
  STREET = 'STREET',
  SURBURB = 'SURBURB',
  PCODE = 'PCODE',
  STATE = 'STATE',
}
